import { ReactNode } from "react";
import useSyncedLocalStorage from "@avinet/adaptive-ui-core/hooks/useSyncedLocalStorage";
import Header from "../components/Header";
import ReleaseNotes from "../components/ReleaseNotes";
import "./PageLayout.scss";

const PageLayout = ({ children }: { children: ReactNode }) => {
  const [, setDismissed] = useSyncedLocalStorage(
    "adaptive-survey-release-notes"
  );
  return (
    <>
      <div className="page-layout">
        <Header />
        {children}
        <footer>
          Adaptive Survey{" "}
          <button
            className="btn-link"
            type="button"
            onClick={() => setDismissed(null)}
          >
            v{process.env.REACT_APP_VERSION}
          </button>
        </footer>
      </div>
      <ReleaseNotes />
    </>
  );
};

export default PageLayout;
